import type { PolicyFormSectionProps } from './PolicyFormSection';
import { YesNoWithConditionalTextAreaFormGroup } from '../../../../YesNoWithConditionalTextAreaFormGroup';

export function NotifyGeneralPractitioner(props: Readonly<PolicyFormSectionProps>) {
    const { data } = props;

    return (
        <>
            {data.hasTreatment === false && (
                <YesNoWithConditionalTextAreaFormGroup
                    fieldKey="shouldNotifyGeneralPractitioner"
                    fieldValue={data.shouldNotifyGeneralPractitioner}
                    isRequired={true}
                    label="Huisarts op de hoogte brengen"
                    textAreaFieldKey="messageToGeneralPractitioner"
                    textAreaLabel="Bericht aan de huisarts"
                />
            )}
        </>
    );
}
